import { DIG_EXP_FIELDS } from 'enums'

const useStatusSections = (expedient, isEasyType = false) => {
  const ineFront = expedient?.documents
    .filter((d) => d.doc_type === DIG_EXP_FIELDS.INE_FRONT)
    .reverse()
    .find(
      (i) => i.doc_type === DIG_EXP_FIELDS.INE_FRONT
        && i?.attachment_url,
    )

  const ineBack = expedient?.documents
    .filter((d) => d.doc_type === DIG_EXP_FIELDS.INE_BACK)
    .reverse()
    .find(
      (i) => ((i.doc_type === DIG_EXP_FIELDS.INE_BACK
        && i?.attachment_url) || i.doc_type === DIG_EXP_FIELDS.PASSPORT_FRONT),
    )

  const circulationCardFront = expedient?.documents
    .filter((d) => d.doc_type === DIG_EXP_FIELDS.CIRCULATION_CARD_FRONT)
    .reverse()
    .find(
      (i) => i.doc_type === DIG_EXP_FIELDS.CIRCULATION_CARD_FRONT
        && i?.attachment_url,
    )

  const circulationCardBack = expedient?.documents
    .filter((d) => d.doc_type === DIG_EXP_FIELDS.CIRCULATION_CARD_BACK)
    .reverse()
    .find(
      (i) => ((i.doc_type === DIG_EXP_FIELDS.CIRCULATION_CARD_BACK
        && i?.attachment_url)),
    )

  const invoiceFront = expedient?.documents
    .filter((d) => d.doc_type === DIG_EXP_FIELDS.INVOICE_FRONT)
    .reverse()
    .find(
      (i) => i.doc_type === DIG_EXP_FIELDS.INVOICE_FRONT
        && i?.attachment_url,
    )

  const invoiceBack = expedient?.documents
    .filter((d) => d.doc_type === DIG_EXP_FIELDS.INVOICE_BACK)
    .reverse()
    .find(
      (i) => ((i.doc_type === DIG_EXP_FIELDS.INVOICE_BACK
        && i?.attachment_url)),
    )

  const ineOldFront = expedient?.documents
    .filter((d) => d.doc_type === DIG_EXP_FIELDS.INE_OLD_FRONT)
    .reverse()
    .find(
      (i) => i.doc_type === DIG_EXP_FIELDS.INE_OLD_FRONT
        && i?.attachment_url,
    )

  const ineOldBack = expedient?.documents
    .filter((d) => d.doc_type === DIG_EXP_FIELDS.INE_OLD_BACK)
    .reverse()
    .find(
      (i) => ((i.doc_type === DIG_EXP_FIELDS.INE_OLD_BACK
        && i?.attachment_url) || i.doc_type === DIG_EXP_FIELDS.PASSPORT_OLD_FRONT),
    )

  const invoiceOld1Front = expedient?.documents
    .filter((d) => d.doc_type === DIG_EXP_FIELDS.INVOICE_OLD_FRONT)
    .reverse()
    .find(
      (i) => i.doc_type === DIG_EXP_FIELDS.INVOICE_OLD_FRONT
        && i?.attachment_url,
    )

  const invoiceOld1Back = expedient?.documents
    .filter((d) => d.doc_type === DIG_EXP_FIELDS.INVOICE_OLD_BACK)
    .reverse()
    .find(
      (i) => ((i.doc_type === DIG_EXP_FIELDS.INVOICE_OLD_BACK
        && i?.attachment_url)),
    )

  const invoiceOld2Front = expedient?.documents
    .filter((d) => d.doc_type === DIG_EXP_FIELDS.INVOICE_OLD2_FRONT)
    .reverse()
    .find(
      (i) => i.doc_type === DIG_EXP_FIELDS.INVOICE_OLD2_FRONT
        && i?.attachment_url,
    )

  const invoiceOld2Back = expedient?.documents
    .filter((d) => d.doc_type === DIG_EXP_FIELDS.INVOICE_OLD2_BACK)
    .reverse()
    .find(
      (i) => ((i.doc_type === DIG_EXP_FIELDS.INVOICE_OLD2_BACK
        && i?.attachment_url)),
    )

  const isIneCompleted = Boolean(ineFront && ineBack)
  const isCirculationCardCompleted = Boolean(circulationCardFront && circulationCardBack)
  const isInvoiceCompleted = Boolean(invoiceFront && invoiceBack)
  const isIneOldCompleted = Boolean(ineOldFront && ineOldBack)
  const isInvoiceOldCompleted = Boolean(invoiceOld1Front && invoiceOld1Back)
  const isInvoiceOld2Completed = Boolean(invoiceOld2Front && invoiceOld2Back)
  const isFinishedValidation = isEasyType
    ? Boolean(isIneOldCompleted
      && isInvoiceOldCompleted)
    : Boolean(isIneCompleted
      && isCirculationCardCompleted
      && isInvoiceCompleted)

  return {
    isIneCompleted,
    isIneOldCompleted,
    isCirculationCardCompleted,
    isInvoiceCompleted,
    isInvoiceOldCompleted,
    isInvoiceOld2Completed,
    isFinished: isFinishedValidation,
  }
}

export default useStatusSections
